export default defineNuxtPlugin(async () => {
  const dashStore = useDashboardStore();
  const token = useCookie<string | null>('userToken');

  if (!token.value || dashStore.getIsUserConnected) {
    return;
  }

  try {
    await dashStore.fetchUserByToken();
  } catch (error) {
    console.error('Failed to hydrate user from cookie', error);
  }
});
